import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { auth, db } from "../../config/firebase";
import { addDoc, collection } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";

interface CreateFormData {
  title: string;
  description: string;
}

export const CreateForm = () => {
  const [user] = useAuthState(auth);

  const schema = yup.object().shape({
    title: yup.string().required("Title is required"),
    description: yup.string().required("Description is required"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<CreateFormData>({
    resolver: yupResolver(schema),
  });

  const postsRef = collection(db, "posts");

  const onCreatePost = async (data: CreateFormData) => {
    await addDoc(postsRef, {
      // title: data.title,
      // description: data.description,
      ...data, // This is shorthand for the 2 above lines

      username: user?.displayName,
      userId: user?.uid,
    });
    // console.log(data);
  };

  return (
    <form onSubmit={handleSubmit(onCreatePost)}>
      <input placeholder="Title..." {...register("title")} />
      <div className="error">{errors.title?.message} &nbsp;</div>

      <br />
      <textarea placeholder="Description..." {...register("description")} />
      <div className="error">{errors.description?.message} &nbsp;</div>

      <input type="submit" className="submitBtn" />
    </form>
  );
};
